<template>
  <section class="filter-section">
    <h2>
      Mitä tarvitset?
      <span class="loading-container" v-if="loading">
        <i class="fal fa-fw fa-spinner-third fa-spin"></i>
        <span class="sr-only">Loading...</span>
      </span>
    </h2>
    <ButtonRow :loading="loading" />
    <CheckBoxColumn :loading="loading" />
  </section>
</template>

<script>
import ButtonRow from "./ButtonRow";
import CheckBoxColumn from "./CheckBoxColumn";

export default {
  name: "FilterSection",
  components: { ButtonRow, CheckBoxColumn },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-section {
  padding: 2rem 0;
}
h2 {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
